class MegaMenuPanel extends HTMLElement {
  constructor() {
    super();
    this.primaryLinks = this.querySelectorAll('.mega-menu__primary-link');
    this.childPanels = this.querySelectorAll('.mega-menu__children');
    this.imagesWrapper = this.querySelector('[data-mega-menu-images]');
    this.imageItems = this.imagesWrapper
      ? this.imagesWrapper.querySelectorAll('.mega-menu__image-item')
      : [];
    this.hoverDelay = 80;
    this.hoverTimer = null;
  }

  connectedCallback() {
    this.primaryLinks.forEach((link) => {
      link.addEventListener('mouseenter', this.onPrimaryEnter.bind(this));
      link.addEventListener('focus', this.onPrimaryEnter.bind(this));
    });

    this.addEventListener('mouseleave', () => {
      window.clearTimeout(this.hoverTimer);
    });

    // Reset to first item whenever the parent <details> closes
    this.detailsElement = this.closest('details');
    if (this.detailsElement) {
      this.detailsElement.addEventListener('toggle', this.onDetailsToggle.bind(this));
    }

    // Show the image for the initially-open link (if any)
    const initiallyOpen = this.querySelector('.mega-menu__primary-link.is-open');
    if (initiallyOpen) {
      this.activateImage(initiallyOpen.getAttribute('data-menu'));
    }
  }

  onDetailsToggle() {
    if (!this.detailsElement.open) {
      this.reset();
    }
  }

  reset() {
    window.clearTimeout(this.hoverTimer);

    this.primaryLinks.forEach((link, index) => {
      link.classList.toggle('is-open', index === 0);
    });

    this.childPanels.forEach((panel, index) => {
      if (index === 0) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    // Reset image to whatever the first primary link points to
    const firstLink = this.primaryLinks[0];
    if (firstLink) {
      this.activateImage(firstLink.getAttribute('data-menu'));
    } else {
      this.activateImage(null);
    }
  }

  onPrimaryEnter(event) {
    const link = event.currentTarget;
    const targetId = link.getAttribute('data-panel-target');
    if (!targetId) return;

    window.clearTimeout(this.hoverTimer);
    this.hoverTimer = window.setTimeout(
      () => this.activate(link, targetId),
      this.hoverDelay
    );
  }

  activate(activeLink, targetId) {
    this.primaryLinks.forEach((link) =>
      link.classList.toggle('is-open', link === activeLink)
    );
    this.childPanels.forEach((panel) => {
      if (panel.id === targetId) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    this.activateImage(activeLink.getAttribute('data-menu'));
  }

  activateImage(menuHandle) {
    if (!this.imageItems.length) return;

    let matched = false;
    this.imageItems.forEach((item) => {
      const isMatch = menuHandle && item.getAttribute('data-image') === menuHandle;
      item.classList.toggle('is-active', isMatch);
      item.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
      if (isMatch) matched = true;
    });

    // If no block matches, ensure all images are hidden (already handled above)
    // This satisfies the "If no matching block exists, keep image area hidden" rule
    if (!matched) {
      this.imageItems.forEach((item) => item.classList.remove('is-active'));
    }
  }
}

if (!customElements.get('mega-menu-panel')) {
  customElements.define('mega-menu-panel', MegaMenuPanel);
}